export const MAX_BLOCKED_DOMAINS = 25;
const defaults = {
  blockFreeEmailDomains: false,
  blockedSpecificDomains: []
};
export default class EmailValidationSettings {
  constructor(props = {}) {
    var _props$blockFreeEmail, _props$blockedSpecifi;
    this.blockFreeEmailDomains = (_props$blockFreeEmail = props.blockFreeEmailDomains) !== null && _props$blockFreeEmail !== void 0 ? _props$blockFreeEmail : defaults.blockFreeEmailDomains;
    this.blockedSpecificDomains = (_props$blockedSpecifi = props.blockedSpecificDomains) !== null && _props$blockedSpecifi !== void 0 ? _props$blockedSpecifi : defaults.blockedSpecificDomains;
  }
  static from(json) {
    if (!json) {
      return new EmailValidationSettings();
    }
    return new EmailValidationSettings({
      blockFreeEmailDomains: json.blockFreeEmailDomains,
      blockedSpecificDomains: json.blockedSpecificDomains
    });
  }
  convertToJSON() {
    return {
      blockFreeEmailDomains: this.blockFreeEmailDomains,
      blockedSpecificDomains: this.blockedSpecificDomains
    };
  }
  equals(other) {
    if (this.blockFreeEmailDomains !== other.blockFreeEmailDomains) return false;
    const a = [...this.blockedSpecificDomains].sort();
    const b = [...other.blockedSpecificDomains].sort();
    return a.length === b.length && a.every((v, i) => v === b[i]);
  }

  /** @deprecated use convertToJSON */
  toJS() {
    return this.convertToJSON();
  }

  /** @deprecated use convertToJSON */
  toJSON() {
    return this.convertToJSON();
  }
}